import { SafeLink } from "@/components/ui/SafeLink";
import { Button } from "@/components/ui/button";
import { SlideFromLeft, SlideFromRight } from "@/components/ui/animations";

export default function Tiles() {
    return (
        <div className="flex flex-col w-full bg-gradient-to-b from-gray-50 to-gray-100 relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-32 h-32 bg-red-500/3 rounded-full blur-3xl"></div>
                <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-gray-900/2 rounded-full blur-3xl"></div>
            </div>

            {/* Education-Grade-Furniture-Solutions */}
            <SlideFromLeft Component={
                <div id="Education-Grade-Furniture-Solutions" className="md:pl-0 lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col  lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full  lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/furniture-bedding-education-learning6.jpg`}
                                alt=" Furnished classroom with grouped tables, blue chairs, and interactive whiteboard—education-grade furniture setup."
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-8 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Education-Grade</span> <br />Furniture Solutions
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Durable, ergonomic school furniture tailored for modern classrooms—from flexible seating to height-adjustable desks. Our solutions are designed to support active learning and adapt to evolving educational needs.
                            </p>

                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Common Areas */}
            <SlideFromRight Component={
                <div id="common-area" className="md:pl-0 lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col  lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full  lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/furniture-bedding-education-common-area1.jpg`}
                                alt="Education common area with study stations, soft seating, and natural light—functional shared space design."
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                Stylish & Functional <br /><span className="hero-text-gradient-red">Common Areas</span>
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Versatile furniture for libraries, breakout zones, and student lounges—built to encourage collaboration and comfort while standing up to heavy use.  From comfortable seating to adaptable desks – we have solutions for every space.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Break Room */}
            <SlideFromLeft Component={
                <div id="break-room" className="md:pl-0 lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col  lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full  lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/NewWebPhotos/EducationPage/hnc-web-break-room.jpg`}
                                alt="Education break room with round tables, soft seating, and kitchenette—staff relaxation space"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Break Room </span> & Social Area Enhancements
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Create warm, functional staff and student café spaces with kitchen appliances and commercial-grade furniture designed for schools and tertiary campuses.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Admin Office */}
            <SlideFromRight Component={
                <div id="secure-casting" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col  lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/fb-office-screens-zoning-hero1.jpg`}
                                alt="Education admin office with ergonomic desks, partitioned workstations, and natural lighting."
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Admin Office</span> Setups
                            </h2>

                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Professional office setups with ergonomic desks, chairs, and storage—streamlining day-to-day school operations with comfort and productivity in mind.
                            </p>

                        </div>
                    </div>
                </div>
            } />
        </div>
    )
}